import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectFreightTypesEnabled } from '../shared/user/user.reducer';
import { IAppState } from './app.reducer';

export const redirectGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IAppState>);
  const result = new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectFreightTypesEnabled).subscribe(({ generalFreightEnabled, containersEnabled, specialisedFreightEnabled }) => {
      if (generalFreightEnabled) {
        observer.next(createUrlTreeFromSnapshot(route, ['/app/order/home']));
      } else if (specialisedFreightEnabled) {
        observer.next(createUrlTreeFromSnapshot(route, ['/app/jobbing/home']));
      } else if (containersEnabled) {
        observer.next(createUrlTreeFromSnapshot(route, ['/app/containers/home']));
      } else {
        observer.next(createUrlTreeFromSnapshot(route, ['/app/dashboard']));
      }

      observer.complete();
    })
  });
  return result
};
